module.exports = __webpack_public_path__ + "static/media/ic_tablet.6849fe80.svg";